// Set Caret Inside Element
// This snippet sets the caret inside an element. It is used in the following components:
export function setCaretInsideElement(document, element) {
  if (!document) {
    return;
  }

  if (!element) {
    return;
  }

  var sel = document.getSelection();

  // Get all text nodes inside the element
  var allTextNodes = getTextNodesIn(element);
  let rangeOG = sel.getRangeAt(0);

  var range = rangeOG.cloneRange();
  range.setStart(
    allTextNodes?.[0] ? allTextNodes?.[0] : element,
    allTextNodes?.[0]?.length ? allTextNodes?.[0]?.length : 0,
  );
  range.setEnd(
    allTextNodes?.[0] ? allTextNodes?.[0] : element,
    allTextNodes?.[0]?.length ? allTextNodes?.[0]?.length : 0,
  );

  sel.removeAllRanges();
  sel.addRange(range);

  return;
}
